// index.js
import Vue from 'vue'
import Vuex from 'vuex'
import * as state from "./state"

Vue.use(Vuex)


const appStore = new Vuex.Store({
    state: {
        arrangeTab:"league-1",
        leagueBasicInfo:{},
        eventHub:null,
        landingUrl:null,
    },
    getters: {
        getArrangeTab: state => {
            return state.arrangeTab
        },
        getLeagueBasicInfo: state => {
            return state.leagueBasicInfo
        },
        getEventHub: state => {
            return state.eventHub
        },
        getLandingUrl: state => {
            return state.landingUrl
        },
    },
    mutations: {
        updateArrangeTab (state, payload) {
            state.arrangeTab = payload
        },
        updateLeagueBasicInfo (state, payload) {
            state.leagueBasicInfo = payload
        },
        updateEventHub (state, payload) {
            state.eventHub = payload
        },
        updateLandingUrl (state, payload) {
            state.landingUrl = payload
        }
    },
    actions: {
    }
});
export default appStore;




// WEBPACK FOOTER //
// ./src/store/index.js